import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { environment } from 'environments/environment';
import { BehaviorSubject, catchError, of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DepartmentService {
  departmentId$ = new BehaviorSubject<string>('');
  constructor(private http: HttpClient) {}

  getDepartment(id: string) {
    return this.http
      .get<{
        id: string;
        name: string;
      }>(`${environment.apiUrl}/api/analytics/departments/${id}`)
      .pipe(
        catchError(() => {
          return of();
        }),
      );
  }

  getDepartments() {
    return this.http.get<{ id: string; name: string }[]>(`${environment.apiUrl}/api/analytics/departments`).pipe(
      catchError(() => {
        return of();
      }),
    );
  }
}
